<script setup lang="ts">
export interface Props {
  icon: string
  contentSize?: string
  iconSize?: string
}

const props = withDefaults(defineProps<Props>(), {
  contentSize: "h-10 w-10",
  iconSize: "text-[20px]",
})
</script>

<template>
  <div
    :class="[
      'border-af-grey-700 flex shrink-0 items-center justify-center rounded-xl border',
      props.contentSize,
    ]"
  >
    <FaIcon :icon="props.icon" :class="props.iconSize" />
  </div>
</template>
